import { useMemo, useState, useEffect, } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import axios from "axios";
import Pagination from "react-js-pagination";
import { JIRA_LINK } from "../../utils/constants";
import ReactTable from '@ashvin27/react-datatable';
import { toast } from "react-toastify";
import Select from "../partials/Select";
import {priorities} from "../../utils/constants";
import { tasksStatuses } from "../../utils/constants";



const Snapshot = ({ auth }) => {
    const [records, setRecords] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [users, setUsers] = useState([])
    const [projects, setProjects] = useState([])
    const [selectedProjects, setSelectedProjects] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([])
    const [selectedPriorities, setSelectedPriorities] = useState([])
    const [selectedStatus, setSelectedStatus] = useState([])
    const [search, setSearch] = useState("")
    const [showAllUsers, setShowAllUsers] = useState(false);
    const fetchSnapshot = async () => {
        try {
            const query = {
                page: activePage,
                perPage: pageSize,
                search,
            };

            const body = {
                users_id: selectedUsers?.map(itm => itm.value) || [],
                priority: selectedPriorities?.map(itm => itm.value) || [],
                ticket_status: selectedStatus?.map(itm => itm.value) || [],
                projects: selectedProjects?.map(itm => itm.value) || [],
            };

            const rawToken = localStorage.getItem("jwtToken");
            const token = rawToken?.replace("Bearer ", "");

            const res = await axios.post(
                `/api/snapshot?${new URLSearchParams(query).toString()}`,
                body,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            const data = res.data?.notifications || [];

            const formatted = data.map((item, index) => ({
                srNo: (activePage - 1) * pageSize + index + 1,
                type: item?.type || "N/A",
                message: item?.message || "N/A",
                priority: item?.priority || "N/A",
                ticket_status: item?.ticket_status || "N/A",
                user_id: item?.user_id,
                createdAt: item?.createdAt,
                updatedAt: item?.updatedAt,
            }));

            setRecords(formatted);
            setTotal(res.data?.total || 0);
        } catch (error) {
            console.error("Error fetching snapshot data:", error.message);
            toast.error("Failed to fetch snapshot data");
        }
    };

    const columns = useMemo(
        () => [
            {
                key: "type",
                text: "Ticket",
                className: "type",
                align: "left",
                sortable: true,
                cell: (record) => (
                    <a
                        href={`${JIRA_LINK}/browse/${record?.type}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {record?.type}
                    </a>
                ),
            },
            {
                key: "message",
                text: "Description",
                className: "message",
                align: "left",
                sortable: true,
            },
            {
                key: "priority",
                text: "Priority",
                className: "priority",
                align: "left",
                sortable: true,
            },
            {
                key: "ticket_status",
                text: "Status",
                className: "ticket_status",
                align: "left",
                sortable: true,
                cell: (record) => <span className={record?.ticket_status === "Ready for QA" ? "badge badge-danger" : "badge"}>{record?.ticket_status}</span>,
            },
            {
                key: "user_id",
                text: "Email",
                className: "user_id",
                align: "left",
                sortable: true,
                cell: (record) => <span>{record?.user_id?.email || "N/A"}</span>,
            },
            {
                key: "createdAt",
                text: "Created At",
                className: "createdAt",
                align: "left",
                sortable: true,
                cell: (record) => (
                    <span>{new Date(record?.createdAt).toDateString()}</span>
                ),
            },
            {
                key: "updatedAt",
                text: "Updated At",
                className: "updatedAt",
                align: "left",
                sortable: true,
                cell: (record) => (
                    <span>{new Date(record?.updatedAt).toDateString()}</span>
                ),
            },
        ],
        [auth?.user]
    );

    const config = {
        page_size: pageSize,
        length_menu: [100, 200, 500],
        filename: "Snapshot",
        no_data_text: "No snapshot records found!",
        button: false,
        language: {
            length_menu: "Show _MENU_ results per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: "Prev",
                next: "Next",
                last: "Last"
            }
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: false,
        show_info: false,
    };

    const handleTableChange = ({ page_size }) => {
        if (page_size && page_size !== pageSize) {
            setPageSize(page_size);
            setActivePage(1);
        }
    };

    const getUsers = () => {
        axios
            .get(`/api/user-data`)
            .then(res => {
                const formattedUsers = res.data?.map(user => ({
                    ...user,
                    value: user._id,
                    label: user.email,
                })) || [];
                setUsers(formattedUsers);
            })
            .catch(error => {
                console.error("Error fetching data:", error.message);
            });
    };


    const getProjects = () => {
        axios
            .get(`/api/getprojects`)
            .then(res => {
                setProjects(res.data?.projects?.map(itm => ({ value: itm?._id, label: itm?.name })) || []);
            })
            .catch(error => {
                console.error("Error fetching data:", error.message);
            });
    };

    useEffect(() => {
        getUsers();
        getProjects()
    }, []);

    useEffect(() => {
        fetchSnapshot()
    }, [search, selectedUsers, selectedProjects, selectedStatus, selectedPriorities, pageSize, activePage]);


    return (
        <div className="wrapper">
            <Navbar />
            <div className="d-flex" id="wrapper">
                <Sidebar />
                <div id="page-content-wrapper">
                    <div className="container-fluid px-2 backdrop-cont mt-2">
                        <div className="mt-2">
                            <div className="d-flex align-items-center">
                                <button
                                    className="btn btn-link"
                                    id="menu-toggle"
                                    onClick={() => {
                                        document.body.classList.toggle("sidebar-expanded");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faList} />
                                </button>
                                <h5 className="text-primary mb-0">Snapshot</h5>
                            </div>
                        </div>
                        <div className="d-flex align-items-center mb-3" >
                            <div className="px-2 pr-2 w-100">
                                <div className="row g-2">
                                    <div className="col-12 col-md-6 col-lg-3 mt-2 position-relative" style={{ zIndex: 111111111 }}>
                                        <div className="filter-item position-relative">
                                            <div
                                                className="position-absolute d-flex  align-items-center"
                                                style={{ top: "-25px", right: "0", zIndex: 2 }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    id="showAllUsers"
                                                    style={{ width: "15px", height: "15px" }}
                                                    className="form-check-input me-1"
                                                    checked={showAllUsers}
                                                    onChange={(e) => setShowAllUsers(e.target.checked)}
                                                />
                                                <label
                                                    className="form-check-label "
                                                    htmlFor="showAllUsers"
                                                    style={{ fontSize: "14px", fontWeight: "500" }}
                                                >
                                                    Select All
                                                </label>
                                            </div>
                                            <Select
                                                allOptions={showAllUsers ? users : users.filter((u) => u.status === 1)}
                                                selectedOptions={selectedUsers}
                                                setSelectedOptions={setSelectedUsers}
                                                placeholder="Select Users"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 11111111 }}>
                                        <div className="filter-item">
                                            <Select
                                                allOptions={priorities}
                                                selectedOptions={selectedPriorities}
                                                setSelectedOptions={setSelectedPriorities}
                                                placeholder="Select Priority"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 111111 }}>
                                        <div className="filter-item">
                                            <Select
                                                allOptions={tasksStatuses}
                                                selectedOptions={selectedStatus}
                                                setSelectedOptions={setSelectedStatus}
                                                placeholder="Select Status"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-3 mt-2" style={{ zIndex: 11111 }}>
                                        <div className="filter-item">
                                            <Select
                                                allOptions={projects}
                                                selectedOptions={selectedProjects}
                                                setSelectedOptions={setSelectedProjects}
                                                placeholder="Select Project"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="task-table px-2 mt-3">
                            <ReactTable
                                config={config}
                                records={records}
                                columns={columns}
                                onChange={handleTableChange}
                            />
                        </div>
                        <div className="d-flex justify-content-start align-items-center my-2 px-2">
                            <span>
                                Showing{" "}
                                {records.length > 0
                                    ? (activePage - 1) * pageSize + 1
                                    : 0}{" "}
                                to{" "}
                                {Math.min((activePage - 1) * pageSize + records.length, total)} of {total} records
                            </span>
                        </div>
                        <div className="d-flex justify-content-center my-3">
                            <Pagination
                                activePage={activePage}
                                itemsCountPerPage={pageSize}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={(pageNumber) => setActivePage(pageNumber)}
                                nextPageText="Next"
                                prevPageText="Prev"
                                firstPageText="First"
                                lastPageText="Last"
                                itemClass="page-item"
                                linkClass="page-link"
                                activeClass="active"
                                activeLinkClass="active"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Snapshot;
